"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePostgresQueryConfig = exports.mapToStringArray = exports.createPostgresQueryParams = void 0;
const common_1 = require("@finley-technologies/common");
const orgProvidedInputQueryParams_1 = require("./orgProvidedInputQueryParams");
const principalBalanceDailyAverageQueryParams_1 = require("./principalBalanceDailyAverageQueryParams");
const principalBalancePointInTimeQueryParams_1 = require("./principalBalancePointInTimeQueryParams");
const tAccountsSumQueryParams_1 = require("./tAccountsSumQueryParams");
exports.createPostgresQueryParams = {
    createPrincipalBalanceDailyAverageQueryParams: principalBalanceDailyAverageQueryParams_1.createPrincipalBalanceDailyAverageQueryParams,
    createPrincipalBalancePointInTimeQueryParams: principalBalancePointInTimeQueryParams_1.createPrincipalBalancePointInTimeQueryParams,
    createTAccountsSumQueryParams: tAccountsSumQueryParams_1.createTAccountsSumQueryParams,
    createOrgProvidedInputQueryParams: orgProvidedInputQueryParams_1.createOrgProvidedInputQueryParams,
};
const mapToStringArray = (obj) => {
    if (common_1.typeguards.isStringArray(obj))
        return obj;
    // no errors
    return [];
};
exports.mapToStringArray = mapToStringArray;
/**
 * Note: this method assumes createParams methods do not return string[],
 * they should always return {[key]:val}
 */
const validatePostgresQueryConfig = ({ postgresQuery, variables, }) => {
    // this needs to be un-destructured to narrow properly
    switch (postgresQuery.type) {
        case 'principalBalanceDailyAverage':
            return (0, exports.mapToStringArray)((0, principalBalanceDailyAverageQueryParams_1.createPrincipalBalanceDailyAverageQueryParams)({
                parameterConfig: postgresQuery.parameterConfig,
                variables,
            }));
        case 'principalBalancePointInTime':
            return (0, exports.mapToStringArray)((0, principalBalancePointInTimeQueryParams_1.createPrincipalBalancePointInTimeQueryParams)({
                parameterConfig: postgresQuery.parameterConfig,
                variables,
            }));
        case 'tAccountsSum':
            return (0, exports.mapToStringArray)((0, tAccountsSumQueryParams_1.createTAccountsSumQueryParams)({
                parameterConfig: postgresQuery.parameterConfig,
                variables,
            }));
        case 'orgProvidedInput':
            return (0, exports.mapToStringArray)((0, orgProvidedInputQueryParams_1.createOrgProvidedInputQueryParams)({
                parameterConfig: postgresQuery.parameterConfig,
                variables,
            }));
        default:
            return [
                `Unknown postgres query config: ${JSON.stringify(postgresQuery)}`,
            ];
    }
};
exports.validatePostgresQueryConfig = validatePostgresQueryConfig;
//# sourceMappingURL=index.js.map